import { render, staticRenderFns } from "./DocFormatCover.vue?vue&type=template&id=61922cf0&scoped=true"
import script from "./DocFormatCover.vue?vue&type=script&lang=js"
export * from "./DocFormatCover.vue?vue&type=script&lang=js"
import style0 from "./DocFormatCover.vue?vue&type=style&index=0&id=61922cf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61922cf0",
  null
  
)

export default component.exports